import { render, staticRenderFns } from "./landing-modal.vue?vue&type=template&id=20e26a7c"
import script from "./landing-modal.vue?vue&type=script&lang=ts"
export * from "./landing-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e26a7c')) {
      api.createRecord('20e26a7c', component.options)
    } else {
      api.reload('20e26a7c', component.options)
    }
    module.hot.accept("./landing-modal.vue?vue&type=template&id=20e26a7c", function () {
      api.rerender('20e26a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/landing-modal.vue"
export default component.exports